export const SET_LOADING_CLIENTS = '@routing/SET_LOADING_CLIENTS';
export const SET_LOADING_SAVE = '@routing/SET_LOADING_SAVE';
export const SET_LOADING_AI_SETTINGS = '@routing/SET_LOADING_AI_SETTINGS';
export const SET_LOADING_REPORT = '@routing/SET_LOADING_REPORT';

export const SET_FILTERS = '@routing/SET_FILTERS';

export const LOAD_INITIAL_DATA_REQUEST = '@routing/LOAD_INITIAL_DATA_REQUEST';
export const LOAD_INITIAL_DATA_SUCCESS = '@routing/LOAD_INITIAL_DATA_SUCCESS';

export const SAVE_ROUTE_REQUEST = '@routing/SAVE_ROUTE_REQUEST';
export const EDIT_ROUTE_REQUEST = '@routing/EDIT_ROUTE_REQUEST';
export const DELETE_ROUTE_REQUEST = '@routing/DELETE_ROUTE_REQUEST';

export const LOAD_ROUTES_REQUEST = '@routing/LOAD_ROUTES_REQUEST';
export const LOAD_ROUTES_SUCCESS = '@routing/LOAD_ROUTES_SUCCESS';

export const ROUTING_LIST = {
  MANUAL: 'manual',
  AI: 'ai'
} as const;

export const GENERATE_AI_ROUTES_REQUEST = '@routing/GENERATE_AI_ROUTES_REQUEST';
export const GENERATE_AI_ROUTES_SUCCESS = '@routing/GENERATE_AI_ROUTES_SUCCESS';

export const LOAD_GENERATE_AI_ROUTES_LIST_REQUEST = '@routing/LOAD_GENERATE_AI_ROUTES_LIST_REQUEST';
export const LOAD_GENERATE_AI_ROUTES_LIST_SUCCESS = '@routing/LOAD_GENERATE_AI_ROUTES_LIST_SUCCESS';

export const LOAD_GENERATE_AI_ROUTE_REQUEST = '@routing/LOAD_GENERATE_AI_ROUTE_REQUEST';
export const LOAD_GENERATE_AI_ROUTE_SUCCESS = '@routing/LOAD_GENERATE_AI_ROUTE_SUCCESS';

export const SAVE_AI_ROUTE_SETTINGS_REQUEST = '@routing/SAVE_AI_ROUTE_SETTINGS_REQUEST';
export const SAVE_AI_ROUTE_SETTINGS_SUCCESS = '@routing/SAVE_AI_ROUTE_SETTINGS_SUCCESS';

export const START_AI_ROUTE_JOB = '@routing/START_AI_ROUTE_JOB';
export const RESTORE_AI_ROUTE_JOB = '@routing/RESTORE_AI_ROUTE_JOB';
export const UPDATE_AI_ROUTE_JOB = '@routing/UPDATE_AI_ROUTE_JOB';
export const CLEAR_AI_ROUTE_JOB = '@routing/CLEAR_AI_ROUTE_JOB';
export const STOP_AI_ROUTE_JOB_POLLING = '@routing/STOP_AI_ROUTE_JOB_POLLING';
export const RESUME_AI_ROUTE_JOB_POLLING = '@routing/RESUME_AI_ROUTE_JOB_POLLING';

export const AI_ROUTE_JOB_STORAGE_KEY = '@isa/aiRouteJob';
export const AI_ROUTE_JOB_POLLING_INTERVAL = 60 * 1000;

export const SET_PAGE = '@routing/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@routing/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@routing/SET_ORDER';
export const SET_ORDERBY = '@routing/SET_ORDERBY';
export const SEARCH = '@routing/SEARCH';
export const SET_WALLET_SUMMARY = '@routing/SET_WALLET_SUMMARY';
